import { QueryClient } from 'react-query';

export const queryClient = new QueryClient();

export const clear = () => {
  // Clear all connected caches
  queryClient.clear();
}